import { APIResponseMany, APIResponseSingle, ContentType, APIRequestParams, ContentTypesUID } from '@/contentTypes';
import axios from '@axios';
import { AxiosPromise } from 'axios';
import qs from 'qs';

export const API_URL = '/app-translation';
export const API_REF = ContentTypesUID.AppTranslation;

export async function getTranslations(query: APIRequestParams<'AppTranslation'> = {}): AxiosPromise<APIResponseSingle<'AppTranslation'>> {
    const params = qs.stringify(query);
    return axios.get(`${API_URL}?${params}`);
}